import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-progress-step',
  templateUrl: './progress-step.component.html',
  styleUrls: ['./progress-step.component.scss'],
})
export class ProgressStepComponent implements AfterViewInit {
  @Input() time: number = 0;
  @Input() text: string = '';
  @Input() activeStep: boolean = false;
  @Input() set progress(val: number) {
    this._progress = val;
    this.setStepProgress();
  }

  _progress = 0;
  @ViewChild('step') step!: ElementRef;

  ngAfterViewInit(): void {
    this.setStepProgress();
  }

  setStepProgress() {
    let el1 = this.step?.nativeElement;
    el1?.style.setProperty(
      '--discreet-progress-bar-step-progress',
      this._progress
    );

    if (this._progress > 0 && this._progress < 100)
      this.activeStep = true;
  }
}
